import type { Questionnaire } from '@/typings/Questionnaire';
import evaluateExpression from '@helpers/evaluateExpression';

const evaluateListFilterExpression = (item: Record<string, unknown>, expression: Questionnaire.Expression): boolean => {
  if (!expression || !expression.expression) {
    return true;
  }

  const variablesWithValues = expression.variables?.map(variable => ({
    ...variable,
    value: item[variable.referenceId],
  })) || [];

  const result = evaluateExpression({
    expression: expression.expression,
    id: 'evaluateListFilterExpression',
    variables: variablesWithValues.reduce((acc, val) => ({
      ...acc,
      [val.variableName]: val.value,
    }), {}),
  });

  return Boolean(result);
};

export default evaluateListFilterExpression;